import { Component, Inject, ViewChild } from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { CropperComponent } from './cropper.component';

@Component({
    selector: 'preview-image-dialog',
    templateUrl: 'preview-image-dialog.html',
})
export class PreviewImageDialog {
    brightness = 0;
    contrast = 0;
    @ViewChild('cropperEl') cropperEl: CropperComponent;
    constructor( @Inject(MAT_DIALOG_DATA) public data: any) {}
    ngAfterViewInit() {
        const crop = this.data.image.crop || {};
        if( crop.b ) {
            this.brightness = crop.b / 100;
        }
        if( crop.c ) {
            this.contrast = crop.c / 100;
        }
    }
    resetOptions() {
        this.brightness = 0;
        this.contrast = 0;
        this.updateCropperEl();
    }
    optionChange(e, filter) {
        this[filter] = e.value;
        this.updateCropperEl();
    }
    updateCropperEl() {
        this.cropperEl.filterImage({
            brightness: this.brightness,
            contrast: this.contrast
        });
        let sizes = Object.keys(this.data.image.sizes);
        const newCrop = {
            b: Math.round(this.brightness * 100),
            c: Math.round(this.contrast * 100)
        }
        const crop = this.data.image.crop;
        if( !crop ) {
            this.data.image.crop = newCrop;
        } else {
            this.data.image.crop = Object.assign(crop, newCrop);
        }
        this.data.image.urlWithParams = this.data.image.url + this.data.image.buildHttpParams(this.data.image.crop);
        for(var i = 0; i < sizes.length; i++) {
            const size = sizes[i];
            let image = this.data.image.sizes[size];
            const copyCrop = JSON.parse(JSON.stringify(newCrop));
            if( image.crop ) {
                this.data.image.sizes[size].crop = Object.assign(image.crop, copyCrop);
            } else {
                this.data.image.sizes[size].crop = Object.assign(copyCrop, {
                    width: image.width,
                    height: image.height
                });
            }
            this.data.image.sizes[size].urlWithParams = this.data.image.url + this.data.image.buildHttpParams(image.crop);
        }
    }
    cleanText(prop) {
        this.data.image[prop] = this.data.image[prop].replace(/(<([^>]+)>)/ig,'');
    }
}